import { IGetBeneficiariesRequest } from '@smiles/voebiz-core-beneficiaries/dist/Types/BeneficiariesApi.types';
import { Dropdown, DropdownOptions } from 'components/Dropdown';
import { useTransactions } from 'contexts/Transactions';
import React, { FC, useCallback, useMemo, useState } from 'react';

import { beneficiariesSort } from 'utils/dropdownLabels';

const TableLabel: FC<{ title: string }> = ({ title }) => {
  const { filter, setFilter } = useTransactions();

  const [currentOrderBy, setCurrentOrderByt] = useState(filter?.sort);

  const [isVisible, setIsVisible] = useState(false);

  const handleSort = useCallback(
    (type: string, by: string) => {
      const sort = type as IGetBeneficiariesRequest['sort'];
      const sortBy = by as IGetBeneficiariesRequest['sortBy'];
      setIsVisible(false);
      setCurrentOrderByt(sort);
      setFilter({ sort, sortBy });
    },
    [setFilter, setIsVisible],
  );

  const sort = beneficiariesSort[title];

  const isSortAsc = useMemo(() => currentOrderBy === 'asc', [currentOrderBy]);

  const isSameSort = useMemo(() => filter?.sortBy === sort.type, [filter?.sortBy, sort.type]);

  const optionsInclude = useMemo<DropdownOptions[]>(
    () =>
      sort.labels.map((item) => ({
        onClick: () => handleSort(item.sort, sort.type),
        label: item.label,
        checked: item.sort === currentOrderBy,
      })),
    [currentOrderBy, handleSort, sort.labels, sort.type],
  );

  const icon = useMemo(() => {
    if (!filter?.sortBy) return 'arrow-down';

    return isSortAsc && isSameSort ? 'arrow-up' : 'arrow-down';
  }, [filter?.sortBy, isSameSort, isSortAsc]);

  return (
    <div className="beneficiaries-dropdown" data-testid="test-table-label">
      <button
        type="button"
        className="menu-trigger"
        onClick={() => setIsVisible(true)}
        data-testid="outside-click-button"
      >
        <div className="title-container">
          <span className={isVisible ? 'orange' : ''}>{title}</span>
          <span className={`table-beneficiaries ${icon}`} />
        </div>
      </button>
      <Dropdown
        close={() => setIsVisible(false)}
        open={isVisible}
        options={optionsInclude}
        id="dropdown-modal-include"
      />
    </div>
  );
};

export default TableLabel;
